import {
  Widget,
  getWidgetProps,
  WPSClient,
  RequestContext,
  DVString,
  safeBool,
} from 'DVWebNodeUtils'
import { Banner } from './components/Banner'
import { isRetail } from './utils/utils'

export interface PangaeaBannerProps  {
  banner?: DVString
  csrfToken: string
  context: RequestContext
}

const getProps: getWidgetProps<PangaeaBannerProps> = global.__SERVER__
  ? async ({ context, enableOnPv, titleID}, api) => {
    const wpsClient = new WPSClient(api)
    // We show banners to recognized Retail customers only
    if ((Boolean(context.customerID) && isRetail(context.domain) || safeBool(enableOnPv))) {
      const response = await wpsClient.GetPangaeaBanner(titleID ? { context, titleID } : { context })
      return {
        ...response,
        context
      }
    } else {
      return undefined
    }
  } : undefined

export const PangaeaBanner: Widget<PangaeaBannerProps> = {
  name: 'pangaea-banner',
  getProps,
  Component: Banner,
}
